document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth < 767) {
        const acc = document.getElementsByClassName("accordion");     
        for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                const panel = this.nextElementSibling;           
                // Toggle panel visibility
                // if (panel.style.maxHeight) {
                //    panel.style.maxHeight = null;
                // } else {
                //    panel.style.maxHeight = panel.scrollHeight + "px";     
                // }
            });
        }
    }
});

//product image slide
if (window.innerWidth > 768) {
  var swiperFeatureImg = new Swiper(".img_slide", {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

//related blog post
var articlePost = new Swiper(".aticle_slide", {
  slidesPerView: 1.15,
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  freeMode: false,
   pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

//recommendations code
setTimeout(function () {
   const recomm_flkty = new Flickity('.recommendations-slider', {
      cellAlign: 'left',
      wrapAround: true,
      groupCells: true,
      pageDots: true,
      prevNextButtons: false,
      contain: true,
      responsive: [
      {
        breakpoint: 769,
        settings: {
          cellAlign: "left",
          initialIndex: 2, 
        }
      }
    ]
    });
  }, 1000);

if ( matchMedia('screen and (max-width: 769px)').matches ) {
  var feturedcol_flkty = new Flickity('.cust_coll.grid', {
    wrapAround: true,
    groupCells: true,
    initialIndex: 1, 
    accessibility: true,
    pageDots: true,
    prevNextButtons: false,
    contain: true
  });
}
// UPSELL PRODUCT ADD TO CART START

document.addEventListener('click', function(event) {
  const button = event.target.closest('.quic-add-btn-main-wapper .upsell_add_to_cart');

  if (button) {
    event.preventDefault();

    const variantId = button.getAttribute('data-variant');
    if (!variantId || isNaN(variantId)) {
      console.error("Invalid or missing variant ID");
      return;
    }

    const arr = [{ id: parseInt(variantId), quantity: 1 }];
    const formData = { items: arr };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json().then(data => {
        if (!response.ok) {
          console.error("Shopify Error:", data);
          throw new Error('Error adding to cart');
        }
        return data;
      });
    })
    .then(function(data) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(function(error) {
      console.error('Final Catch Error:', error);
    });
  }
});

//slideshow video play pause & mute unmute
document.addEventListener('DOMContentLoaded', function () {
  // Play/Pause Button
  document.querySelectorAll('.slider_play_btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const slide = btn.closest('.slideshow__slide');
      const video = slide ? slide.querySelector('video') : null;

      if (video) {
        if (video.paused) {
          video.play();
          btn.setAttribute('data-action', 'pause');
        } else {
          video.pause();
          btn.setAttribute('data-action', 'play');
        }
      }
    });
  });

  // Mute/Unmute Button
  document.querySelectorAll('.slider_audioBtn').forEach(function (audioBtn) {
    audioBtn.addEventListener('click', function () {
      const slide = audioBtn.closest('.slideshow__slide');
      const video = slide ? slide.querySelector('video') : null;
      const muteIcon = audioBtn.querySelector('.muteSVG_icon');
      const unmuteIcon = audioBtn.querySelector('.unmuteSVG_icon');

      if (video) {
        video.muted = !video.muted;

        // Toggle icons
        if (video.muted) {
          muteIcon.style.display = 'block';
          unmuteIcon.style.display = 'none';
        } else {
          muteIcon.style.display = 'none';
          unmuteIcon.style.display = 'block';
        }
      }
    });
  });
});


//custom video play
document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".custom_play_btn");

  playButtons.forEach((playBtn) => {
    const videoId = playBtn.dataset.target;
    const posterId = playBtn.dataset.poster;
    const video = document.getElementById(videoId);
    const poster = document.getElementById(posterId);

    if (video && poster) {
      playBtn.addEventListener("click", function () {
        poster.style.display = "none";
        video.classList.remove("hidden");
        video.style.display = "block";
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => console.log("Video playing"))
            .catch((error) => console.error("Video play error:", error));
        }
      });
    }
  });
});

//testcenter scroll
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.breadcrum_btn a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = this.getAttribute('href');
      var targetEl = document.querySelector(targetId);
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});
